import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getWorkspaceResources: {
        route: "/workspaces/:workspaceId/resources",
        method: "GET"
    }
};
